import { Drawer } from "antd";
import AddPolicySubjectWizard from "./AddPolicySubjectWizard";
import styled from "styled-components";
import { useAddPolicySubjectContext } from "./AddPolicySubjectContext";
import { IconLoading } from "../../../../config/icons";
import { Subject } from "../../../../redux/apiSpecifications/apiSubjects";
import { useTranslation } from "react-i18next";

const DrawerContent = styled.div`
  // padding: 2em;
  // position: relative;
  display: flex;
  flex-direction: column;
  gap: 2em;

  .ant-form-item-explain {
    color: red !important;
  }

  .loader-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2em 2em 0 2em;
    z-index: 101;

    .loader {
      width: 6em;
      height: 6em;
    }
  }
`;

const RefreshingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 101;
  display: flex;
  justify-content: center;

  .box {
    width: 10em;
    display: flex;
    justify-content: center;
  }
`;

interface IAddPolicySubjectWizardProps {
  open: boolean;
  onAddPolicySubject: (
    addPolicySubjectData: Subject,
    policySubjectRoles: string[]
  ) => void;
  onClose: () => void;
}

const AddPolicySubjectWizardFullScreen = ({
  open,
  onAddPolicySubject,
  onClose,
}: IAddPolicySubjectWizardProps) => {
  const { t } = useTranslation();
  
  const { apiInteractingStatus, addPolicySubjectData, policySubjectRole } =
    useAddPolicySubjectContext();

  const handleOnAddPolicySubject = () => {
    onAddPolicySubject(addPolicySubjectData!, policySubjectRole!.split("&"));
  };

  return (
    <Drawer
      closable={true}
      open={open}
      width="100VW"
      onClose={onClose}
      destroyOnClose={true}
      title={t("TITLE.add-policy-subject-wizard-full-screen")}
    >
      <DrawerContent>
        {open === true && (
          <>
            <AddPolicySubjectWizard
              onAddPolicySubject={handleOnAddPolicySubject}
            />

            {apiInteractingStatus === "refreshing" && (
              <RefreshingWrapper>
                <div className="box">{IconLoading}</div>
              </RefreshingWrapper>
            )}
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default AddPolicySubjectWizardFullScreen;
